module.exports = __webpack_public_path__ + "img/bg2.ba6c1eed.jpg";